import { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import type { Post } from '@/interfaces/strapi';
import { ROUTES } from '@/constants';

type PostCardProps = {
	readonly className?: string;
	readonly item: Post;
	readonly categorySlug: string;
};

const classNameComponent = 'c-cnm-post-card';

export const PostCard = ({ className, item, categorySlug }: PostCardProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const href = `${ROUTES.ACTUALIDAD}/${categorySlug}/${item.slug}`;
	const date = new Date(item.publishedAt ?? item.createdAt).toLocaleDateString('es-ES', {
		year: 'numeric',
		month: 'long',
		day: '2-digit',
	});

	return (
		<article className={`${wrapperClassName} o-grid__row`}>
			<div className="o-grid__col-12 o-grid__col-3@desktop">
				<Link to={href}>
					{item.image?.url ? (
						<img
							src={item.image.url}
							alt={item.image.alt}
							className={`${classNameComponent}__image`}
							loading="lazy"
						/>
					) : null}
				</Link>
			</div>
			<div className="o-grid__col-12 o-grid__col-9@desktop">
				<Link to={href} className={`${classNameComponent}__link`}>
					<time className={`${classNameComponent}__date`}>{date}</time>
					<h3 className={`${classNameComponent}__title`}>{item.name}</h3>
				</Link>
			</div>
		</article>
	);
};
